export const createUpdateUsersForTenderRequestPayload = (selectedUsers, preSelectedUsers) => {
    const authorizeUserIds = selectedUsers.filter((userId) => !(preSelectedUsers !== null && preSelectedUsers !== void 0 ? preSelectedUsers : []).includes(userId));
    const deauthorizeUserIds = (preSelectedUsers !== null && preSelectedUsers !== void 0 ? preSelectedUsers : []).filter((userId) => !selectedUsers.includes(userId));
    return {
        updateUsersForTenderRequest: Object.assign(Object.assign({}, (authorizeUserIds.length > 0 && {
            authorizeUsers: authorizeUserIds,
        })), (deauthorizeUserIds.length > 0 && {
            deauthorizeUsers: deauthorizeUserIds,
        })),
    };
};
